<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { computed } from 'vue'
import AppIcon from '@layer/components/elements/AppIcon.vue'
import { useTenantLogo } from '@ui/composables/useTenantLogo'
import AppLogo from '@ui/components/chargecloud/AppLogo.vue'

const { t } = useI18n()
const route = useRoute()
const { hasTenantLogo } = useTenantLogo()

const backLink = computed(() => {
  return route.query.from === 'login' ? '/auth/login' : '/auth/registration'
})
</script>

<template>
  <div class="bg-gray-50 min-h-screen">
    <!-- Header with Logo and Back Button -->
    <header class="bg-white top-0 z-10">
      <div class="container mx-auto px-4 py-2 sm:px-8 sm:py-4">
        <div class="flex h-[84px] items-center justify-between">
          <div class="flex items-center">
            <AppLogo v-if="hasTenantLogo" size="sm" />
          </div>
          <NuxtLink
            :to="backLink"
            class="flex items-center gap-2 rounded-md px-2 py-2 text-base text-black hover:underline"
          >
            <AppIcon name="fa6-solid:arrow-left" size="sm" color="black" />
            <span class="hidden sm:inline">{{ t('common.back') }}</span>
          </NuxtLink>
        </div>
      </div>
    </header>

    <!-- Main Content -->
    <main class="container mx-auto mt-4 p-4 sm:p-8">
      <div>
        <slot />
      </div>
    </main>

    <!-- Footer -->
    <footer class="mt-8 border-t border-accent-02/10">
      <div class="container mx-auto px-4 py-6">
        <div class="flex justify-center text-sm text-accent-03">
          <p>© {{ new Date().getFullYear() }} {{ t('layout.copyright') }}</p>
        </div>
      </div>
    </footer>
  </div>
</template>
